
      import { PreferPortal, ReleaseRegions } from './src/js/common/keys.js';
      import { portalPageMapping } from './src/js/app/utils/portal-page-mapping.js';
      import { isProfileInReleaseRegion } from './src/js/app/utils/release-region.js';

      (async () => {
        try {
          if (window.imsLoaded) {
            await window.imsLoaded;
          }
          if (!window.adobeIMS?.isSignedInUser()) return;

          const profile = await window.adobeIMS?.getProfile();
          if (!profile?.email) return;

          const storedToggleStatus = localStorage.getItem(`${PreferPortal}_${profile.email}`);
console.log("VITE_IS_ROLLBACK_ACTIVE ====>", import.meta.env.VITE_IS_ROLLBACK_ACTIVE)
console.log("VITE_RELEASE_REGIONS ====>", import.meta.env.VITE_RELEASE_REGIONS)
          var rollBackLocal = null;  //localStorage.getItem('rollBackLocal'); // Stage and Dev Testing Perpose 
          var isRollbackActive = rollBackLocal !== null
            ? rollBackLocal === 'true'
            : String(import.meta.env.VITE_IS_ROLLBACK_ACTIVE || '').toLowerCase() === 'true';

          if (storedToggleStatus === 'true' || storedToggleStatus === null) {
            //const releaseRegions = localStorage.getItem(ReleaseRegions) || import.meta.env.VITE_RELEASE_REGIONS || 'APAC';
            const releaseRegions = import.meta.env.VITE_RELEASE_REGIONS || 'APAC';
            const inRegion = await isProfileInReleaseRegion(releaseRegions);

            if (storedToggleStatus === 'true') {
              portalPageMapping({ persisted: true });
              return;
            }

            if (storedToggleStatus === null && !isRollbackActive && inRegion) {
              portalPageMapping({ persisted: true });
              return;
            }
          }
        } catch (error) {
          // Not fatal — support.js below performs the same check as a fallback.
        }
      })();
    